import { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';
import { useLocation } from 'react-router-dom';
import { metaInfo } from 'constants/RegistrationForm/constants';

const MetaHelmet = ({ initialUrl }) => {
  const location = useLocation();
  const [currentUrl, setCurrentUrl] = useState(initialUrl || location.pathname);

  useEffect(() => {
    setCurrentUrl(location.pathname);
  }, [location]);

  const { title, description } = metaInfo[currentUrl] || metaInfo.default;

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
    </Helmet>
  );
};

export default MetaHelmet;
